import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PartDesignItemStructure } from 'src/app/models/domain';
import {
  ItemStructureAdapter,
  PartDesignItemStructureAdapter,
} from 'src/app/models/domain/adapters';
import {
  IItemStructureDTO,
  ILEGORESTAPIEnvelope,
  IMCodesEnvelope,
  IPartDesignItemStructureDTO,
} from 'src/app/models/legorestapi';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LegoRestApiDataService {
  public constructor(
    private readonly httpClient: HttpClient,
    private readonly partDesignItemStructureAdapter: PartDesignItemStructureAdapter,
    private readonly itemStructureAdapter: ItemStructureAdapter
  ) {}

  public getItemStructureById(itemId: string): Observable<PartDesignItemStructure | undefined> {
    return this.httpClient
      .get<ILEGORESTAPIEnvelope<IPartDesignItemStructureDTO>>(
        `${environment.legoRestApiUrl}/lookup/structure/${itemId}`,
        {
          withCredentials: true,
        }
      )
      .pipe(
        map((result) => {
          // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
          return result?._DATA
            ? this.partDesignItemStructureAdapter.adaptToDomain(result._DATA)
            : undefined;
        })
      );
  }

  public getMouldDesignItemStructureByConstructionId(constructionId: string) {
    return this.getItemStructureByConstructionId(`MD${constructionId}`);
  }

  public getMouldCavityItemStructureByConstructionId(constructionId: string) {
    return this.getItemStructureByConstructionId(`MC${constructionId}`);
  }

  public getMCodes(itemId: string, revisionId: string) {
    return this.httpClient
      .get<ILEGORESTAPIEnvelope<IMCodesEnvelope>>(
        `${environment.legoRestApiUrl}/mcodes/${itemId}/${revisionId}`,
        {
          withCredentials: true,
        }
      )
      .pipe(
        map((result) => {
          // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
          return result?._DATA ? result._DATA.mcodes.map((mcode) => mcode.mcode) : undefined;
        })
      );
  }

  private getItemStructureByConstructionId(constructionId: string) {
    return this.httpClient
      .get<ILEGORESTAPIEnvelope<IItemStructureDTO>>(
        `${environment.legoRestApiUrl}/lookup/structure/${constructionId}`,
        {
          withCredentials: true,
        }
      )
      .pipe(
        map((result) => {
          // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
          return result?._DATA ? this.itemStructureAdapter.adaptToDomain(result._DATA) : undefined;
        })
      );
  }
}
